export const ListQueryKey = 'withdraws';
export const DetailQueryKey = 'withdraw';
export const Urls = {
  selectUrl: '/withdraw/list',
  updateUrl: '/withdraw/update',
  deleteUrl: '/withdraw/delete',
  createUrl: '/withdraw/create',
  detailUrl: '/withdraw/info'
};